export default "__VITE_ASSET__6a032def__"